<div class="citation-snippet" [class.sidebar-mode]="sidebarMode">
  @if (!sidebarMode) {
    <div class="citation-top-line"></div>
  }

  <div class="citation-body">
    <div class="citation-index">[{{ index }}]</div>

    <div class="citation-content-wrapper">
      @if (hasFullContent) {
        <div class="citation-content">
          <h3 class="citation-title">{{ title }}</h3>
          @if (publishedDate) {
            <p class="citation-date">
              {{ "CITATION.PUBLISHED" | translate }}: {{ publishedDate }}
            </p>
          }
          <div class="description-wrapper">
            <p class="citation-description" [class.expanded]="isExpanded">
              {{ description }}
            </p>
            @if (!isExpanded) {
              <button class="expand-button" (click)="toggleExpand()">
                {{ "CITATION.EXPAND_SNIPPET" | translate }}
              </button>
            } @else {
              <button class="collapse-button" (click)="toggleExpand()">
                {{ "CITATION.COLLAPSE_SNIPPET" | translate }}
              </button>
            }
          </div>
          <p class="citation-source">
            {{ "CITATION.Source" | translate }}:
            <a [href]="source" target="_blank" rel="noopener noreferrer">{{
              title
            }}</a>
          </p>
        </div>
      } @else if (hasPartialContent) {
        <div class="citation-content">
          <div class="description-wrapper">
            <p class="citation-description" [class.expanded]="isExpanded">
              {{ description }}
            </p>
            @if (!isExpanded) {
              <button class="expand-button" (click)="toggleExpand()">
                {{ "CITATION.EXPAND_SNIPPET" | translate }}
              </button>
            } @else {
              <button class="collapse-button" (click)="toggleExpand()">
                {{ "CITATION.COLLAPSE_SNIPPET" | translate }}
              </button>
            }
          </div>
          <p class="citation-source">
            {{ "CITATION.Source" | translate }}:
            <a [href]="source" target="_blank" rel="noopener noreferrer">{{
              title || source
            }}</a>
          </p>
        </div>
      } @else {
        <div class="citation-content">
          <p class="citation-source">
            {{ "CITATION.Source" | translate }}:
            <a [href]="source" target="_blank" rel="noopener noreferrer">{{
              title || source
            }}</a>
          </p>
        </div>
      }

      <p class="citation-powered">{{ poweredByText }}</p>
    </div>
  </div>
</div>
